
import angular from 'angular';

const controllerInfo = {
    module: 'ib-insurance-allianz-fusion-module',
    inject: ['$uibModalInstance', 'object', '$scope', '$rootScope', 'localStorageService', 'AncillariesConstants'],
    required: []
};
export class InsuranceAncAllianzFusionModalController implements ng.IController {
    public model: AncillariesModel.modelModalInsurance;

    public market:string = this.$rootScope.appMarket;
    public insuranceForm;
    public isUSMarket:boolean = false;
    public isDNIBound:boolean = !!((this.market === 'ES' || this.market === 'IT'));
    public policyHolder:any;
    public requiredByNavigationMarket: any;
    public requiredByStatesSelector: any;
    public codeStateSelected: any;
    public patternResidentDocument: string;
    public patternZipCode: string;
    public patternEmail: string;
    public patternCity: string;
    public passengersTransformed: any;
    public passengersForInsurance: any[];
    public flowApp: string;
    constructor (
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private object: any,
        private $scope: angular.IScope,
        private $rootScope: CommonsRootScope,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private AncillariesConstants: AncillariesConstant) {
        this.model = object;
    }

    /**
     * Initialize modal controller
     */
    $onInit (): void {
        this.extractInfoFromInfant();
        const flowApp = this.localStorageService.get('flowApp');
        if (this.model.passengers.length > 0 && flowApp === 'BBKI') this.setPassengerNames();
        this.policyHolder = this.passengersForInsurance.filter(passenger => passenger.passengerType === 'ADULT')[0];
        const listUSMarkets = ['US', 'BR', 'MX'];
        listUSMarkets.forEach(market => {
            if(market === this.market) {
                this.isUSMarket = true;
            }
        });
        this.setStatesSelector();
        this.checkRequiredFields();
        this.getPatterns();
        this.getFlowApp();
    }

    extractInfoFromInfant ()  {
        const adultsWithInfants = this.model.passengersInfo.context.passengers.filter(passenger => passenger.infant);
        const insuranceInfants = adultsWithInfants.map( passenger => {
            return passenger.infant;
        });
        this.passengersForInsurance = this.model.passengersInfo.context.passengers.concat(insuranceInfants);
    }


    setPassengerNames () {
        const passengersTransformed= this.passengersForInsurance.map(passengerForInsurance => {
            let name, surname;
            let passengerFinded = this.model.passengers.find(passenger => (passenger.passengerId || passenger.id) === passengerForInsurance.id);
            if( !passengerFinded ) {
                passengerFinded = this.model.passengers.find(passenger => (passenger.passengerId || passenger.id) === passengerForInsurance.id);
                return {
                    ...passengerForInsurance,
                    surname: (passengerFinded?.personalInfo?.infant?.surname || passengerFinded?.info?.infant?.surname),
                    name: (passengerFinded?.personalInfo?.infant?.name || passengerFinded?.info?.infant?.name)
                };
            }

            return {
                ...passengerForInsurance,
                surname: (passengerFinded?.personalInfo?.surname || passengerFinded?.info?.surname),
                name: (passengerFinded?.personalInfo?.name || passengerFinded?.info?.name)
            };
        });

        this.passengersForInsurance = passengersTransformed;
    }

    getFlowApp () {
        this.flowApp = this.localStorageService.get('flowApp');
    }
    setStatesSelector () {
        this.requiredByStatesSelector = this.AncillariesConstants.STATES_SELECTOR.NAMES;
    }

    checkRequiredFields = (): void => {
        this.requiredByNavigationMarket = this.model.insuranceRequirements.filter(requirement => requirement.countries.find(country => country === this.market))[0];
    };

    changeInsurancePolicyHolder = (selected:any): void => {
        this.policyHolder = selected;
    };
    changeCountrySelected = (selected:any): void => {
        this.model.insurance.countryPassenger = selected;
    };
    changeStateSelected = (selected:any): void => {
        this.model.insurance.statePassenger = selected;
        for (let i=0; i < this.AncillariesConstants.STATES_SELECTOR.NAMES.length; i++) {
            if (selected === this.AncillariesConstants.STATES_SELECTOR.NAMES[i]) {
                this.codeStateSelected = this.AncillariesConstants.STATES_SELECTOR.CODES[i];
            }
        }
    };
    getPatterns = () => {
        if (this.market === 'ES') {
            this.patternResidentDocument = '/^([a-zA-Z]{1}\\d{7}|\\d{8})[a-zA-Z]{1}$/';
            //this.patternResidentDocument = this.model.insuranceRequirements[2].passengerTypeRequiredFields[0].requiredFieldsGroups[1].requiredFields[0].pattern;
        } else {
            this.patternResidentDocument = '/^[a-zA-Z]{6}\\d{2}[a-zA-Z]\\d{2}[a-zA-Z]\\d{3}[a-zA-Z]/';
            this.patternZipCode = '/^[0-9]+$/';
            //this.patternResidentDocument = this.model.insuranceRequirements[1].passengerTypeRequiredFields[0].requiredFieldsGroups[1].requiredFields[0].pattern;
        }
        this.patternZipCode = '/^[0-9]+$/';
        this.patternEmail = '/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$/';
        this.patternCity = '/^[ a-zA-Z]+$/';
    };
    close = (): void => {
        this.$uibModalInstance.close();
        angular.element('ib-insurance-allianz-fusion').find('.ib-radio__input:checked').prop('checked', false);
    };

    completeForm = (): void => {
        this.insuranceForm.$submitted = true;
        if (this.insuranceForm.$valid) {
            const data = this.model.insurance;
            const requestData:any = [];
            this.passengersForInsurance.forEach((pas, index)  => {
                if (pas === this.model.policyHolder) {
                    if (this.isDNIBound) {
                        requestData.push({
                            passengerId: this.model.policyHolder.id,
                            passengerType: this.model.policyHolder.passengerType,
                            policyHolder: true,
                            values: [
                                {
                                    type: 'INSURED_BIRTH_DATE',
                                    value: this.model.insurance.passenger &&  (this.model.insurance.passenger[index]?.birthDateYear.year + '-' + this.model.insurance.passenger[index].birthDateMonth + '-' + this.model.insurance.passenger[index].birthDateDay)
                                },
                                {
                                    type: 'INSURED_FIRSTNAME',
                                    value: this.model.policyHolder.name
                                },
                                {
                                    type: 'INSURED_LASTNAME',
                                    value: this.model.policyHolder.surname
                                },
                                {
                                    type: 'POLICY_HOLDER_ADDRESS_ZIPCODE',
                                    value: this.model.insurance.zipcodePassenger
                                },
                                {
                                    type: 'POLICY_HOLDER_ADDRESS_COUNTRY',
                                    value: this.model.insurance.countryPassenger
                                },
                                {
                                    type: 'POLICY_HOLDER_ADDRESS_CITY',
                                    value: this.model.insurance.cityPassenger
                                },
                                {
                                    type: 'POLICY_HOLDER_CONTACT_EMAIL',
                                    value: this.model.insurance.emailPassenger
                                },
                                {
                                    type: 'POLICY_HOLDER_NUMBER_DOCUMENT',
                                    value: this.model.insurance.passengerDocument
                                }
                            ]
                        }
                        );
                    } else if (this.isUSMarket) {
                        const lines = this.model.insurance.addressSecond === undefined ? this.model.insurance.addressFirst : this.model.insurance.addressFirst + ';' + this.model.insurance.addressSecond;
                        requestData.push(
                            {   passengerId: this.model.policyHolder.id,
                                passengerType: this.model.policyHolder.passengerType,
                                policyHolder: true,
                                values: [
                                    {
                                        type: 'INSURED_BIRTH_DATE',
                                        value:  this.model.insurance.passenger &&  (this.model.insurance.passenger[index]?.birthDateYear.year + '-' + this.model.insurance.passenger[index].birthDateMonth + '-' + this.model.insurance.passenger[index].birthDateDay)
                                    },
                                    {
                                        type: 'INSURED_FIRSTNAME',
                                        value: this.model.policyHolder.name
                                    },
                                    {
                                        type: 'INSURED_LASTNAME',
                                        value: this.model.policyHolder.surname
                                    },
                                    {
                                        type: 'POLICY_HOLDER_ADDRESS_ZIPCODE',
                                        value: this.model.insurance.zipcodePassenger
                                    },
                                    {
                                        type: 'POLICY_HOLDER_ADDRESS_COUNTRY',
                                        value: this.model.insurance.countryPassenger
                                    },
                                    {
                                        type: 'POLICY_HOLDER_ADDRESS_CITY',
                                        value: this.model.insurance.cityPassenger
                                    },
                                    {
                                        type: 'POLICY_HOLDER_CONTACT_EMAIL',
                                        value: this.model.insurance.emailPassenger
                                    },
                                    {
                                        type: 'POLICY_HOLDER_ADDRESS_STATE',
                                        value: this.codeStateSelected
                                    },
                                    {
                                        type: 'POLICY_HOLDER_ADDRESS_LINES',
                                        value: lines
                                    }
                                ]
                            }
                        );
                    } else {
                        requestData.push(
                            {   passengerId: this.model.policyHolder.id,
                                passengerType: this.model.policyHolder.passengerType,
                                policyHolder: true,
                                values: [
                                    {
                                        type: 'INSURED_BIRTH_DATE',
                                        value:  this.model.insurance.passenger &&  (this.model.insurance.passenger[index]?.birthDateYear.year + '-' + this.model.insurance.passenger[index].birthDateMonth + '-' + this.model.insurance.passenger[index].birthDateDay)
                                    },
                                    {
                                        type: 'INSURED_FIRSTNAME',
                                        value: this.model.policyHolder.name
                                    },
                                    {
                                        type: 'INSURED_LASTNAME',
                                        value: this.model.policyHolder.surname
                                    },
                                    {
                                        type: 'POLICY_HOLDER_ADDRESS_ZIPCODE',
                                        value: this.model.insurance.zipcodePassenger
                                    },
                                    {
                                        type: 'POLICY_HOLDER_ADDRESS_COUNTRY',
                                        value: this.model.insurance.countryPassenger
                                    },
                                    {
                                        type: 'POLICY_HOLDER_ADDRESS_CITY',
                                        value: this.model.insurance.cityPassenger
                                    },
                                    {
                                        type: 'POLICY_HOLDER_CONTACT_EMAIL',
                                        value: this.model.insurance.emailPassenger
                                    }
                                ]
                            });
                    }
                } else {
                    requestData.push(
                        {   passengerId: this.passengersForInsurance[index].id,
                            passengerType: this.passengersForInsurance[index].passengerType || 'INFANT',
                            policyHolder: false,
                            values: [
                                {
                                    type: 'INSURED_BIRTH_DATE',
                                    value: this.model.insurance.passenger &&  (this.model.insurance.passenger[index]?.birthDateYear.year + '-' + this.model.insurance.passenger[index].birthDateMonth + '-' + this.model.insurance.passenger[index].birthDateDay)
                                },
                                {
                                    type: 'INSURED_FIRSTNAME',
                                    value: this.passengersForInsurance[index].name
                                },
                                {
                                    type: 'INSURED_LASTNAME',
                                    value: this.passengersForInsurance[index].surname
                                }
                            ]
                        });
                }
                this.localStorageService.set('insuranceAllianzFusionPassengerInfo', requestData);
            });
            this.$uibModalInstance.close();
        }
    };
}


try {
    InsuranceAncAllianzFusionModalController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(InsuranceAncAllianzFusionModalController.name, InsuranceAncAllianzFusionModalController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    InsuranceAncAllianzFusionModalController.$inject = controllerInfo.inject;
    mod.controller(InsuranceAncAllianzFusionModalController.name, InsuranceAncAllianzFusionModalController);
}